/* Nuvò · Homepage — skin test, «Aggiungi», carosello reel, domande e risposte */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function addToCart(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      document.dispatchEvent(new CustomEvent('nuvo:cart:added'));
      return r.json();
    });
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* ---------- skin test ---------- */
  function initTest(sec) {
    if (sec.dataset.nhReady) return;
    var raw = sec.querySelector('[data-nh-test-data]');
    if (!raw) return;
    var d;
    try { d = JSON.parse(raw.textContent); } catch (e) {
      var q0 = sec.querySelector('[data-q]');
      if (q0) q0.textContent = 'Skin test: dati non leggibili (' + e.message + ')';
      return;
    }
    sec.dataset.nhReady = '1';
    var money = function (c) {
      try { return new Intl.NumberFormat(d.loc || 'it-IT', { style: 'currency', currency: d.cur || 'EUR' }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
    };
    var steps = [{ q: d.q1, key: 'need', opts: d.needs }, { q: d.q2, key: 'skin', opts: d.skins }];
    var st = { step: 0, need: null, skin: null };
    var tabs = sec.querySelectorAll('.nh-tab');
    var ask = sec.querySelector('[data-ask]'), res = sec.querySelector('[data-res]');
    var qEl = sec.querySelector('[data-q]'), optsEl = sec.querySelector('[data-opts]');
    var back = sec.querySelector('[data-back]'), ans = sec.querySelector('[data-ans]');
    var items = sec.querySelector('[data-items]'), total = sec.querySelector('[data-total]');
    var addAll = sec.querySelector('[data-addall]'), restart = sec.querySelector('[data-restart]');
    var ok = sec.querySelector('[data-ok]'), err = sec.querySelector('[data-err]');
    var addLabel = addAll.textContent, current = [];
    var arrow = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="M13 6l6 6-6 6"></path></svg>';

    function label(i, k) {
      var o = steps[i].opts.filter(function (x) { return x.k === k; })[0];
      return o ? o.l : '';
    }
    function render() {
      tabs.forEach(function (t, i) {
        t.classList.toggle('is-on', i === Math.min(st.step, 2));
        t.classList.toggle('is-past', i < st.step);
      });
      var asking = st.step < 2;
      ask.hidden = !asking; res.hidden = asking;
      if (asking) {
        var cur = steps[st.step];
        qEl.textContent = cur.q;
        optsEl.textContent = '';
        cur.opts.forEach(function (o) {
          var b = el('button', 'nh-opt' + (o.img ? '' : ' nh-opt--noimg'));
          b.type = 'button';
          b.setAttribute('aria-label', o.l);
          if (o.img) { var im = el('img'); im.src = o.img; im.alt = ''; im.loading = 'lazy'; b.appendChild(im); }
          b.appendChild(el('span', 'nh-opt__ov', o.l));
          b.addEventListener('click', function () { st[cur.key] = o.k; st.step += 1; render(); });
          optsEl.appendChild(b);
        });
        back.hidden = st.step === 0;
        return;
      }
      ans.textContent = '';
      ans.appendChild(el('i', '', label(0, st.need)));
      ans.appendChild(el('i', '', label(1, st.skin)));
      var codes = String(d.map[st.need + '_' + st.skin] || '').toUpperCase().replace(/[^A-Z]/g, '').split('');
      current = codes.map(function (c) { return d.products[c]; }).filter(Boolean);
      items.textContent = '';
      var sum = 0;
      current.forEach(function (p) {
        sum += p.price;
        var a = el('a', 'nh-res__it'); a.href = p.url;
        var ph = el('span', 'nh-res__ph');
        if (p.img) { var im = el('img'); im.src = p.img; im.alt = p.name; im.loading = 'lazy'; ph.appendChild(im); }
        a.appendChild(ph);
        a.appendChild(el('span', 'nh-res__cat', p.cat));
        a.appendChild(el('span', 'nh-res__name', p.name));
        a.appendChild(el('span', 'nh-res__price', money(p.price)));
        a.appendChild(el('span', 'nh-res__see', d.see));
        items.appendChild(a);
      });
      total.textContent = money(sum);
      addAll.textContent = addLabel; addAll.disabled = false;
      ok.hidden = true; err.hidden = true;
    }
    back.addEventListener('click', function () { st.step = Math.max(0, st.step - 1); render(); });
    restart.addEventListener('click', function () { st = { step: 0, need: null, skin: null }; render(); });
    addAll.addEventListener('click', function () {
      if (!current.length) return;
      addAll.disabled = true; err.hidden = true;
      addToCart(current.map(function (p) { return { id: p.vid, quantity: 1 }; }))
        .then(function () { addAll.textContent = d.added; ok.hidden = false; })
        .catch(function () { addAll.disabled = false; err.hidden = false; });
    });
    render();
  }

  /* ---------- bottone «Aggiungi» delle card ---------- */
  function initAdd(btn) {
    if (btn.dataset.nhReady) return;
    btn.dataset.nhReady = '1';
    var label = btn.textContent;
    btn.addEventListener('click', function () {
      btn.disabled = true;
      addToCart([{ id: Number(btn.dataset.nhAdd), quantity: 1 }])
        .then(function () {
          btn.textContent = btn.dataset.nhAdded || label;
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2500);
        })
        .catch(function () { btn.disabled = false; });
    });
  }

  /* ---------- carosello reel (solo mobile) ---------- */
  function initReels(box) {
    if (box.dataset.nhReady) return;
    box.dataset.nhReady = '1';
    var reels = box.querySelectorAll('[data-reel]');
    var prev = box.querySelector('[data-prev]'), next = box.querySelector('[data-next]');
    var i = 0;
    function show() {
      reels.forEach(function (r, n) {
        r.classList.toggle('is-on', n === i);
        if (n !== i) { var v = r.querySelector('video'); if (v) v.pause(); }
      });
      prev.disabled = i === 0;
      next.disabled = i >= reels.length - 1;
    }
    prev.addEventListener('click', function () { i = Math.max(0, i - 1); show(); });
    next.addEventListener('click', function () { i = Math.min(reels.length - 1, i + 1); show(); });
    show();
  }

  /* ---------- domande e risposte: apri/chiudi tutto ---------- */
  function initFaq(sec) {
    if (sec.dataset.nhReady) return;
    sec.dataset.nhReady = '1';
    var btn = sec.querySelector('[data-toggle]'), list = sec.querySelector('[data-list]');
    if (!btn || !list) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      list.hidden = open;
    });
  }

  function init() {
    document.querySelectorAll('[data-nh-test]').forEach(initTest);
    document.querySelectorAll('[data-nh-add]').forEach(initAdd);
    document.querySelectorAll('[data-nh-reels]').forEach(initReels);
    document.querySelectorAll('[data-nh-faq]').forEach(initFaq);
  }
  window.NuvoHomeInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
